<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    // 判断是否移动端，直接跳走
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // 写个异步，正常拿的路由老是空的
      setTimeout(() => {
        if (this.$route.fullPath.indexOf('mobile') === -1) {
          this.$router.replace('/mobile/home')
        }
      }, 100);
    }
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 1);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #193759;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.mainContainer {
  width: 100vw;
  margin: auto;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  font-family: "Microsoft YaHei";

  .headerCtn {
    position: fixed;
    max-height: 100px;
    background: transparent;
    left: 0;
    right: 0;
    z-index: 99;
    color: rgba(255, 255, 255, .9);
    overflow: hidden;
    transition: 0.2s linear;

    &.headerShow {
      max-height: 310px;

      .nav {
        transform: translateX(0) !important;
        opacity: 1 !important;
      }
    }

    &.animation {
      background: #fff;
      color: #333;
      box-shadow: 0px 0px 10px rgba(15, 91, 183, 0.1);
    }

    .main {
      min-width: 1200px;
      width: calc(100vw - 540px);
      margin: auto;
      min-height: 100px;
      display: flex;
      justify-content: space-between;

      .leftLogo {
        height: 100px;
        display: flex;
        align-items: center;

        .logo {
          // width: 60px;
          height: 50px;
          // margin-right: 12px;
          display: flex;
          align-items: center;
          font-size: 30px;
          font-weight: 700;
          letter-spacing: 2px;
          line-height: 1;
          white-space: nowrap;
        }

        .name {
          .span1 {
            font-size: 32px;
            letter-spacing: 2px;
          }

          .span2 {
            font-size: 24px;
          }
        }
      }

      .rightNav {
        font-size: 18px;
        display: flex;
        align-items: center;

        .title {
          position: relative;
          cursor: pointer;
          margin-left: 60px;

          &.phone {
            cursor: text;

            .el-icon-phone-outline {
              margin-right: 6px;
            }
          }

          &:hover:not(.phone) {
            color: #009BFB;

            .line {
              left: 6px;
              right: 6px;
            }
          }

          &.active {
            color: #009BFB;

            .line {
              left: 6px;
              right: 6px;
            }
          }

          .line {
            position: absolute;
            height: 4px;
            background: #009BFB;
            left: 50%;
            right: 50%;
            bottom: -10px;
            border-radius: 2px;
            margin: auto;
            transition: 0.25s linear;
          }
        }
      }
    }

    .navCtn {
      width: calc(100vw - 540px);
      min-width: 1200px;
      overflow: hidden;
      margin: auto;

      .navMain {
        display: flex;
        width: 725px;
        float: right;
        margin-right: 162px;
        margin-bottom: 22px;
      }

      .navLeft {
        flex: 1;
        margin-right: 24px;

        .nav {
          transform: translateX(-85px);
        }
      }

      .navMiddle {
        flex: 1;

        .nav {
          transform: translateY(55px);
        }
      }

      .navRight {
        flex: 1;

        .nav {
          transform: translateX(85px);
        }
      }

      .nav {
        opacity: 0;

        // &:nth-child(1) {
        //   .navText {
        //     cursor: default;
        //     font-size: 18px;
        //     font-weight: bold;

        //     &:hover {
        //       color: #333 !important;
        //     }
        //   }
        // }

        .navText {
          cursor: pointer;
          line-height: 36px;
          text-align: left;

          &:hover {
            color: #009BFB;
          }
        }

        &:nth-child(1) {
          transition: 0.6s ease transform 0.1s;
        }

        &:nth-child(2) {
          transition: 0.58s ease transform 0.12s;
        }

        &:nth-child(3) {
          transition: 0.56s ease transform 0.14s;
        }

        &:nth-child(4) {
          transition: 0.54s ease transform 0.16s;
        }

        &:nth-child(5) {
          transition: 0.52s ease transform 0.18s;
        }
      }
    }
  }

  .detailScreen {
    width: 100vw;
    padding-top: 100px;

    .headImage {
      width: 100vw;
      min-height: 500px;
      // background: rgba(0, 0, 0, .8);
      position: relative;

      img {
        width: 100%;
      }

      .titleCtn {
        position: absolute;
        bottom: 12%;
        width: 40%;
        // background: rgba(110, 111, 114, 0.8);
        // background-image: linear-gradient(180deg, #2B2C27, #5A5F5F);
        background-color: rgba(129, 126, 126, 0.2);
        /* 半透明背景 */
        backdrop-filter: blur(10px);
        /* 创建毛玻璃效果 */
        padding: 30px 40px;
        color: #fff;
        animation: flyIn ease 0.6s 1;
        text-align: center;

        @keyframes flyIn {
          0% {
            transform: translateX(-100%);
          }

          100% {
            transform: translateX(0);
          }
        }

        .title {
          font-weight: bold;
          text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
          font-size: 48px;
          margin-bottom: 12px;
          text-align: center;
          font-family: Arial, Helvetica, sans-serif;
        }



        .info {
          font-size: 18px;
          line-height: 42px;
          text-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
          text-align: left;
          display: inline-block;
        }

        .btnCtn {
          margin-top: 32px;
          display: flex;
          justify-content: center;
        }

        .button {
          line-height: 50px;
          color: rgba(255, 255, 255);
          border: 2px solid;
          border-radius: 30px;
          text-align: center;
          font-size: 20px;
          display: inline-block;
          padding: 0 30px;
          cursor: pointer;
          margin: 0 24px;

          &:hover {
            color: rgba(255, 255, 255, .9);
          }
        }
      }
    }

    .navCtn {
      line-height: 60px;
      display: flex;
      padding-left: 20px;
      box-shadow: 0px 0px 10px rgba(15, 91, 183, 0.1);


      .tag {
        margin-right: 20px;

        &::after {
          content: '>';
          margin-left: 20px;
        }

        &:nth-last-child(1) {
          color: #009BFB;

          &::after {
            content: '';
          }
        }
      }
    }
  }

  .contentCtn {
    margin: 40px auto;
    padding: 40px 0;
    width: calc(100vw - 540px);
    min-width: 1200px;
    position: relative;

    &.hasBack {
      &::before {
        content: '';
        position: absolute;
        top: -40px;
        bottom: -40px;
        left: -270px;
        right: -270px;
        background: rgba(182, 215, 255, 0.1);
        z-index: -1;
      }
    }

    .titleCtn {
      text-align: center;
      transform: scale(0.1);
      opacity: 0.1;
      transition: 1s ease;
      margin-bottom: 36px;

      &.animation {
        transform: scale(1);
        opacity: 1;
      }

      .title {
        color: #262626;
        letter-spacing: 2px;
        position: relative;
        z-index: 2;
        font-size: 32px;
        font-weight: bold;
      }

      .titleTranslate {
        color: #eeeeee;
        letter-spacing: 4px;
        transform: translateY(40px);
        z-index: 1;
        font-family: Arial #262626;
        font-size: 64px;
        font-weight: bold;
      }
    }

    .infoCtn {
      margin: 40px auto;
      text-align: center;

      .info {
        font-size: 16px;
        color: #7A7A7A;
        line-height: 32px;
        text-indent: 2em;
        text-align: justify;
        opacity: 0;
        transform: translateY(50px);
        transition: 1s ease;
        display: inline-block;

        &.animation {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }
  }

  .bottomBox {
    // height: 288px;
    background: #333;
    color: #fff;

    .main {
      width: 800px;
      margin: auto;
      display: flex;
      height: 100%;
      box-sizing: border-box;
      padding: 46px 0;

      .box {
        flex: 1;
        display: flex;
        justify-content: start;
        flex-direction: column;

        &:nth-child(2) {
          position: relative;

          &::before {
            content: '';
            width: 1px;
            height: 120px;
            background: #fff;
            position: absolute;
            left: 0;
            top: 46px;
            bottom: 0;
            margin: auto;
          }

          &::after {
            content: '';
            width: 1px;
            height: 120px;
            background: #fff;
            position: absolute;
            right: 0;
            top: 46px;
            bottom: 0;
            margin: auto;
          }
        }

        .title {
          font-size: 16px;
          margin-bottom: 28px;
          height: 22px;
          line-height: 22px;
          text-align: left;
          padding-left: 24px;

          &.click {
            cursor: pointer;

            &:hover {
              color: #009BFB;
            }
          }
        }

        .line {
          font-size: 14px;
          line-height: 36px;

          span {
            cursor: pointer;
            display: inline-block;
            padding-left: 24px;

            &.unclick {
              cursor: text;

              &:hover {
                color: #fff;
              }
            }

            &:hover {
              color: #009BFB;
            }

            &:nth-child(1) {
              margin-right: 12px;
            }
          }
        }

        .ercode {
          display: flex;
          flex-direction: column;
          width: 90px;

          img {
            width: 90px;
            height: 90px;
          }

          span {
            margin-top: 12px;
            text-align: center;
          }
        }

        .logo {
          height: 100%;
          display: flex;
          align-items: center;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 2px;
          white-space: nowrap;

          img {
            max-width: 100px;
          }
        }
      }
    }

    .icpCtn {
      text-align: center;
      padding-bottom: 20px;
      line-height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
      }

      a {
        cursor: pointer;
        text-decoration: none;
        color: inherit;

        &:hover {
          color: #009BFB;
        }
      }
    }
  }
}

.mobileContentCtn {
  padding-top: 40px;

  .imgAndText {
    width: 100%;
    position: relative;

    .img {
      width: 100%;
    }

    .text {
      position: absolute;
      background-color: rgba(129, 126, 126, 0.2);
      /* 半透明背景 */
      backdrop-filter: blur(10px);
      bottom: 20%;
      left: 0;
      color: #000b12;
      line-height: 50px;
      padding: 0 20px;
      font-size: 18px;
    }
  }

  .mobileContent {
    .titleCtn {
      text-align: center;
      margin-bottom: 20px;

      .title {
        color: #262626;
        letter-spacing: 2px;
        position: relative;
        z-index: 2;
        font-size: 16px;
        font-weight: bold;
      }

      .titleTranslate {
        color: #eeeeee;
        letter-spacing: 1px;
        transform: translateY(10px);
        z-index: 1;
        font-family: Arial #262626;
        font-size: 20px;
        font-weight: bold;
      }
    }

    .infoCtn {
      margin: 20px auto;
      text-align: center;

      .info {
        font-size: 14px;
        color: #7A7A7A;
        line-height: 32px;
        text-indent: 2em;
        text-align: justify;
        display: inline-block;
        padding: 0 20px;
      }

      .boxCtn {
        display: flex;
        justify-content: space-between;
        margin: auto;
        margin-bottom: 12px;
        cursor: pointer;
        padding: 0 20px;

        .box {
          flex: 1;
          height: 140px;
          display: flex;
          flex-direction: column;
          justify-content: end;
          position: relative;
          overflow: hidden;

          .image {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: -1;
          }

          .titleAndText {
            height: 46px;
            background: rgba(0, 0, 0, 0.6);
            overflow: hidden;
            color: #fff;

            .title {
              height: 46px;
              padding: 0 8px;

              .span1 {
                line-height: 24px;
                font-size: 12px;
              }

              .span2 {
                line-height: 22px;
                font-size: 12px;
              }
            }
          }

          &:nth-child(1) {
            margin-right: 12px;
          }
        }
      }
    }

    .imageCenter {
      width: 70%;
      margin: 20px auto;

      .image {
        width: 100%;
      }
    }

  }
}
</style>
